import type * as Types from '../../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTenantDisplayNamesQueryVariables = Types.Exact<{
  withDeniedTenants: Types.Scalars['Boolean'];
}>;


export type GetTenantDisplayNamesQuery = { __typename?: 'Query', tenantDisplayNames: Array<{ __typename?: 'TenantNamePair', id: string, tenantName: string, tenantRole: Types.TenantRole, approvalStatus: Types.ApprovalStatus }> };


        export type ExecGetTenantDisplayNamesOptions = Omit<
        Apollo.QueryOptions<
        GetTenantDisplayNamesQueryVariables, GetTenantDisplayNamesQuery
        >,
        "query"
      >;
    export const execGetTenantDisplayNamesQuery = (options: ExecGetTenantDisplayNamesOptions) =>
    client.query< GetTenantDisplayNamesQuery, GetTenantDisplayNamesQueryVariables>({
      ...options,
      query: GetTenantDisplayNamesDocument,
    });
    

export const GetTenantDisplayNamesDocument = gql`
    query getTenantDisplayNames($withDeniedTenants: Boolean!) {
  tenantDisplayNames(withDeniedTenants: $withDeniedTenants) {
    id
    tenantName
    tenantRole
    approvalStatus
  }
}
    `;

/**
 * __useGetTenantDisplayNamesQuery__
 *
 * To run a query within a React component, call `useGetTenantDisplayNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantDisplayNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantDisplayNamesQuery({
 *   variables: {
 *      withDeniedTenants: // value for 'withDeniedTenants'
 *   },
 * });
 */
export function useGetTenantDisplayNamesQuery(baseOptions: Apollo.QueryHookOptions<GetTenantDisplayNamesQuery, GetTenantDisplayNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantDisplayNamesQuery, GetTenantDisplayNamesQueryVariables>(GetTenantDisplayNamesDocument, options);
      }
export function useGetTenantDisplayNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantDisplayNamesQuery, GetTenantDisplayNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantDisplayNamesQuery, GetTenantDisplayNamesQueryVariables>(GetTenantDisplayNamesDocument, options);
        }
export type GetTenantDisplayNamesQueryHookResult = ReturnType<typeof useGetTenantDisplayNamesQuery>;
export type GetTenantDisplayNamesLazyQueryHookResult = ReturnType<typeof useGetTenantDisplayNamesLazyQuery>;
export type GetTenantDisplayNamesQueryResult = Apollo.QueryResult<GetTenantDisplayNamesQuery, GetTenantDisplayNamesQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;